import { useI18n } from '../i18n';
import { LangSwitcher } from '../components/LangSwitcher';

/**
 * Standalone support page at /:locale/support (and unprefixed /support
 * as a fallback). Linked from the App Store / Play Store metadata as the
 * "Support URL". Apple requires a public webpage (not a mailto: link),
 * so this page exists primarily to surface info@insert-coin.io behind a
 * stable HTTPS URL plus a short FAQ for the most common requests.
 */
export function Support() {
  const { t, localePath } = useI18n();
  const email = 'info@insert-coin.io';
  return (
    <main class="legal-page">
      <div class="legal-page__shell">
        <div class="legal-page__top">
          <a class="legal-page__back" href={localePath('/')}>← BeerCup</a>
          <LangSwitcher theme="light" />
        </div>
        <h1 class="legal-page__title">{t('support.title')}</h1>
        <div class="legal-page__body">
          <p>{t('support.intro')}</p>

          <h2>{t('support.contact_heading')}</h2>
          <p>
            {t('support.contact_lead')}{' '}
            <a href={`mailto:${email}`}>{email}</a>
          </p>
          <p class="legal-page__muted">{t('support.contact_sla')}</p>

          <h2>{t('support.faq_heading')}</h2>

          <h3>{t('support.q_signin')}</h3>
          <p>{t('support.a_signin')}</p>

          <h3>{t('support.q_voucher')}</h3>
          <p>{t('support.a_voucher')}</p>

          <h3>{t('support.q_change_email')}</h3>
          <p>{t('support.a_change_email')}</p>

          <h3>{t('support.q_delete')}</h3>
          <p>
            {t('support.a_delete_lead')}{' '}
            <a href={localePath('/account/delete')}>
              {t('support.a_delete_link')}
            </a>
            {t('support.a_delete_tail')}
          </p>

          <h3>{t('support.q_data')}</h3>
          <p>
            {t('support.a_data_lead')}{' '}
            <a href={`mailto:${email}`}>{email}</a>
            {t('support.a_data_tail')}
          </p>

          <h3>{t('support.q_18')}</h3>
          <p>{t('support.a_18')}</p>
        </div>
        <nav class="legal-page__nav" aria-label="legal pages">
          <a href={localePath('/privacy')}>{t('legal.privacy_title')}</a>
          <span>·</span>
          <a href={localePath('/terms')}>{t('legal.terms_title')}</a>
          <span>·</span>
          <a href={localePath('/account/delete')}>{t('account.delete.title')}</a>
        </nav>
      </div>
    </main>
  );
}
